// ===========================================
// Student Layout Context - Type Definitions
// ===========================================
// Types for the student dashboard layout preference system

import { createContext } from 'react';

export type LayoutMode = 'professional' | 'fun';

export interface StudentLayoutState {
  layoutMode: LayoutMode;
  isInitialized: boolean;
}

export interface StudentLayoutContextValue extends StudentLayoutState {
  setLayoutMode: (mode: LayoutMode) => void;
  toggleLayout: () => void;
}

export const StudentLayoutContext = createContext<StudentLayoutContextValue | null>(null);
